import { observer } from 'mobx-react-lite';
import React from 'react';

import { CharacterItem } from './character-item';
import { AssetGrid } from '../../../components/grid';

import type { Character } from '../../../app/entities/character';

import styles from './character-cards.module.scss';
type CharacterCardsProps = {
  characters: Character[];
};

export const CharacterCards: React.FC<CharacterCardsProps> = observer(({ characters }) => {
  // Read in number order so the list itself shows the order of appearance. Unnumbered
  // characters sort last; `name` breaks ties, because duplicate numbers are legal (PRO-1083).
  const ordered = [...(characters ?? [])].sort((a, b) => {
    const left = a.characterNumber ?? Number.POSITIVE_INFINITY;
    const right = b.characterNumber ?? Number.POSITIVE_INFINITY;

    return left === right ? a.name.localeCompare(b.name) : left - right;
  });

  return (
    <AssetGrid className={styles['container']}>
      {ordered.map((character) => (
        <CharacterItem key={character._id} character={character} />
      ))}
    </AssetGrid>
  );
});
